var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"data-placeholder":_vm.placeholder,"multiple":_vm.multiple,"disabled":_vm.disabled}},_vm._l((_vm.customOptions),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v("\n        "+_vm._s(option.label)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }